var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-btn',{attrs:{"id":"auth-btn","size":"md","push":"","color":"primary","icon":"fab fa-steam","type":"a","href":`${_vm.apiEndPoint}auth/steam`,"rounded":"","padding":"15px 15px","label":"Авторизоваться","loading":_vm.authLoading},on:{"click":function($event){_vm.authLoading = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }